// src/routes/LoginRoutes.js
import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/Auth/MinimalLayout';
import PublicRoute from 'routes/PublicRoute';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/Register')));
const AuthRegisterAdmin = Loadable(lazy(() => import('pages/auth/RegisterAdmin')));
const ForgotPassword = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('pages/auth/ResetPassword')));
const PendingApproval = Loadable(lazy(() => import('pages/auth/PendingApproval')));
const Unauthorized = Loadable(lazy(() => import('pages/auth/Unauthorized')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: (
        <PublicRoute>
          <AuthLogin />
        </PublicRoute>
      )
    },
    {
      path: 'register',
      element: (
        <PublicRoute>
          <AuthRegister />
        </PublicRoute>
      )
    },
    {
      path: 'register-admin',
      element: (
        <PublicRoute>
          <AuthRegisterAdmin />
        </PublicRoute>
      )
    },
    {
      path: 'register-vendor',
      element: (
        <PublicRoute>
          <AuthRegisterAdmin />
        </PublicRoute>
      )
    },
    {
      path: 'register-client',
      element: (
        <PublicRoute>
          <AuthRegisterAdmin />
        </PublicRoute>
      )
    },
    {
      path: 'register-opex-vendor',
      element: (
        <PublicRoute>
          <AuthRegisterAdmin />
        </PublicRoute>
      )
    },
    {
      path: 'register-subcontractor',
      element: (
        <PublicRoute>
          <AuthRegisterAdmin />
        </PublicRoute>
      )
    },
    {
      path: 'forgot-password',
      element: (
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      )
    },
    {
      path: 'reset-password',
      element: (
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      )
    },
    {
      path: 'pending-approval',
      element: <PendingApproval />
    },
    {
      path: 'unauthorized',
      element: <Unauthorized />
    }
  ]
};

export default LoginRoutes;
